<template>
  <div class="dashboard-section coach-dash-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="dashboard-menu coaurt-menu-dash">
            <ul>
              <li>
                <router-link to="/coaches/coach-dashboard">
                  <img src="@/assets/img/icons/dashboard-icon.svg" alt="Icon" />
                  <span>Dashboard</span>
                </router-link>
              </li>
              <li>
                <router-link to="/coaches/all-court">
                  <img src="@/assets/img/icons/court-icon.svg" alt="Icon" />
                  <span> Courts</span>
                </router-link>
              </li>
              <li>
                <router-link to="/coaches/coach-request">
                  <img src="@/assets/img/icons/request-icon.svg" alt="Icon" />
                  <span>Requests</span>
                  <span class="court-notify">03</span>
                </router-link>
              </li>
              <li>
                <router-link to="/coaches/coach-booking">
                  <img src="@/assets/img/icons/booking-icon.svg" alt="Icon" />
                  <span>Bookings</span>
                </router-link>
              </li>
              <li>
                <router-link to="/coaches/coach-chat">
                  <img src="@/assets/img/icons/chat-icon.svg" alt="Icon" />
                  <span>Chat</span>
                </router-link>
              </li>
              <li>
                <router-link to="/coaches/coach-earning">
                  <img src="@/assets/img/icons/invoice-icon.svg" alt="Icon" />
                  <span>Earnings</span>
                </router-link>
              </li>
              <li>
                <router-link to="/coaches/coach-wallet">
                  <img src="@/assets/img/icons/wallet-icon.svg" alt="Icon" />
                  <span>Wallet</span>
                </router-link>
              </li>
              <li>
                <router-link to="/coaches/coach-profile">
                  <img src="@/assets/img/icons/profile-icon.svg" alt="Icon" />
                  <span>Profile Setting</span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
